import { defineMessages } from 'react-intl';

const ID_PREFIX = 'WacSignupForm.';
export const messages = defineMessages({
  header: {
    id: `${ID_PREFIX}header`,
    defaultMessage: 'Great, check your inbox'
  },
  devopsHeader: {
    id: `${ID_PREFIX}devopsHeader`,
    defaultMessage: 'Your suite is ready!'
  },
  devopsSubHeader: {
    id: `${ID_PREFIX}devopsSubHeader`,
    defaultMessage: 'Activate your account to log in'
  },
  devopsNoResendNoEmail: {
    id: `${ID_PREFIX}devopsNoResendNoEmail`,
    defaultMessage:
      "<div>Didn't receive an email from us?</div> Check your spam folder or try resending the email below."
  },
  devopsEmailSent: {
    id: `${ID_PREFIX}devopsEmailSent`,
    defaultMessage:
      "We've sent an email to <div>{email}</div> with a link to activate your account."
  },
  resendEmailLineOne: {
    id: `${ID_PREFIX}resendEmailLineOne`,
    defaultMessage: "We've emailed a verification link to:"
  },
  resendEmailLineTwo: {
    id: `${ID_PREFIX}resendEmailLineTwo`,
    defaultMessage: 'It will expire shortly, so verify soon.'
  },
  resendEmailCheckSpam: {
    id: `${ID_PREFIX}resendEmailCheckSpam`,
    defaultMessage: 'Remember to check your spam folder.'
  },
  resendEmailAction: {
    id: `${ID_PREFIX}resendEmailAction`,
    defaultMessage: 'Resend Email'
  },
  resendEmailChangeEmail: {
    id: `${ID_PREFIX}resendEmailChangeEmail`,
    defaultMessage: 'Need to change your email address?'
  },
  resendEmailChangeEmailAction: {
    id: `${ID_PREFIX}resendEmailChangeEmailAction`,
    defaultMessage: "You'll need to create a new account."
  },
  resendEmailStillNoEmail: {
    id: `${ID_PREFIX}resendEmailStillNoEmail`,
    defaultMessage: 'Still not getting the email? We can help.'
  },
  resendEmailCreateAHelpTicket: {
    id: `${ID_PREFIX}resendEmailCreateAHelpTicket`,
    defaultMessage: 'Create a help ticket.'
  },
  noResendNoEmail: {
    id: `${ID_PREFIX}noResendNoEmail`,
    defaultMessage: "Didn't receive an email from us?"
  },
  noResendEmailConfirmation: {
    id: `${ID_PREFIX}noResendEmailConfirmation`,
    defaultMessage:
      'Email confirmation helps us to ensure your data will always be safe.'
  },
  noResendContactUsHtml: {
    id: `${ID_PREFIX}noResendContactUsHtml`,
    defaultMessage: '<a href="/company/contact">Contact us.</a>'
  }
});
